<template>
  <div class="f-col ctr login">
    <div class="f-col login-message">
      <span class="error-message" v-show="isAuthError">{{ errorMessage }}</span>
    </div>
    <form class="f-col ctr" @submit.prevent="handleSubmit">
      <div class="f-row ctr form-field">
        <label class="f-row ctr" for="username-field">
          <Icon icon="user" />
          <span class="hidden">Email</span>
        </label>
        <input
          class="f-row ctr"
          id="username-field"
          type="email"
          name="username"
          placeholder="Email"
          required
          v-model="email"
        />
      </div>
      <div class="f-row ctr form-field">
        <label class="f-row ctr" for="password-field">
          <Icon icon="lock" />
          <span class="hidden">Senha</span>
        </label>
        <input
          class="f-row ctr"
          id="password-field"
          type="password"
          name="password"
          placeholder="Senha"
          required
          v-model="password"
        />
      </div>
      <div class="f-row ctr form-submit">
        <button class="button-submit" type="submit" :disabled="isAuthLoading">
          <template v-if="isAuthLoading">
            <Icon
              icon="spinner"
              spin
              style="font-size: 22px; animation-duration: 1.2s"
            />
          </template>
          <template v-else>Acessar</template>
        </button>
      </div>
    </form>
    <div class="f-row ctr">
      <p class="redefine-message">
        Esqueceu a senha?
        <button @click="switchToForgotten">Clique aqui</button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
    };
  },
  computed: {
    isAuthLoading() {
      return this.$store.state.auth.status === 'loading';
    },
    isAuthError() {
      return this.$store.state.auth.status === 'error';
    },
  },
  methods: {
    switchToForgotten() {
      this.$store.commit('PRELUDE_UPDATE_CONTEXT', 'forgotten');
    },
    async handleSubmit() {
      try {
        if (this.isAuthLoading) return;
        const { email, password } = this;
        await this.$store.dispatch('AUTH_REQUEST', { email, password });
        this.$router.push('/');
      } catch (err) {
        this.errorMessage = !(err.name === 'TypeError')
          ? err.message
          : 'Não foi possível realizar esta operação';
        this.password = '';
        document?.querySelector('#password-field')?.focus();
      }
    },
  },
};
</script>

<style scoped>
.login {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.login-message {
  font-size: 14px;
  min-height: 22px;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
}

.error-message {
  color: #f33;
  white-space: pre-line;
}

.form-field {
  margin: 6px;
}

.form-field > input {
  width: 180px;
  height: 54px;
  padding: 0 16px;
  font-size: 14px;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #f2f2f6;
}

.form-field > label {
  height: 54px;
  width: 56px;
  font-size: 14px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  background-color: #7e8e9edf;
}

.form-submit {
  margin: 6px;
}

.button-submit {
  width: 268px;
  height: 54px;
  font-weight: 700;
  text-transform: uppercase;
  color: #eee;
  background-color: #25aae1;
  border-radius: 0.25rem;
}

.redefine-message {
  margin: 6px;
  font-size: 14px;
  color: #9f9f9f;
}

.redefine-message > button {
  padding: 0 2px;
  font-size: 14px;
  color: #f1f1f1;
}
</style>
